import styled from "styled-components";

export const BottomNavbarContainer = styled.nav`
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: 16px;
  height: 65px;
  background: var(--color-primary-gradient);
  /* background-color: var(--color-white, #ffffff); */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
  padding: 0 20px;
  overflow: visible;
  border-radius: 20px;

  /* Solo visible en móviles */
  @media (min-width: 769px) {
    display: none;
  }
`;

export const NavItem = styled.button`
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  padding: 8px;
  min-width: 65px;
  width: 65px;
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  position: relative;

  .nav-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: ${({ $isActive }) => ($isActive ? "50px" : "28px")};
    min-width: ${({ $isActive }) => ($isActive ? "50px" : "28px")};
    height: ${({ $isActive }) => ($isActive ? "50px" : "28px")};
    width: ${({ $isActive }) => ($isActive ? "50px" : "28px")};
    border-radius: 50%;
    transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    flex-shrink: 0;
    /* position: relative; */

    /* Círculo blanco grande que sobresale completamente */
    ${({ $isActive }) =>
      $isActive &&
      `
      background-color: var(--color-primary);
      transform: translateY(-30px);
      position: absolute;

      /* Borde decorativo */
      &::before {
        content: '';
        position: absolute;
        inset: -7px;
        border-radius: 50%;
        border-bottom: 8px solid var(--color-white, #ffffff);
        border-right: 8px solid var(--color-white, #ffffff);
        border-left: 8px solid var(--color-white, #ffffff);
        z-index: -1;
      }
    `}

    /* Los iconos de Font Awesome se estilizan directamente */
    svg, i {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
    }
  }

  .nav-label {
    font-size: 11px;
    font-weight: ${({ $isActive }) => ($isActive ? "600" : "500")};
    color: ${({ $isActive }) =>
      $isActive ? "var(--color-white, #007bff)" : "#999999"};
    transition: all 0.3s ease;
    white-space: nowrap;
    margin-top: ${({ $isActive }) => ($isActive ? "34px" : "2px")};
  }

  &:hover {
    opacity: 0.8;
  }

  &:active {
    transform: scale(0.95);
  }
`;
